import { createFileRoute } from '@tanstack/react-router'
import { IdentitiesScreen } from '@/components/identities/identities-screen'
import { RowsSkeleton, ViewBarSkeleton } from '@/components/shell/screen-skeletons'
import { requireAnalyticsAccess } from '@/lib/queries/analytics-access'

export const Route = createFileRoute('/o/$org/identities/')({
  beforeLoad: ({ context: { queryClient }, params: { org } }) =>
    requireAnalyticsAccess({ queryClient, orgSlug: org }),
  pendingComponent: () => (
    <>
      <ViewBarSkeleton />
      <RowsSkeleton />
    </>
  ),
  component: IdentitiesScreen,
})
